module.exports = __webpack_public_path__ + "img/7.f013fd82.jpg";